import { LimitedMetaDto, LowStockMetaDto } from '@services/MarppleShop/features/ProductMeta';
import { TNessBadgeListViewProps } from '@modules/Ness/App/ProductBadge';
import { isLegacyStockProduct } from '@services/MarppleShop/features/ProductList';

/**
 * @ness-only
 * legacy 뱃지 데이터 생성 코드 ts로 말아놓은 함수
 */
export const convertToNessBadgeProps = (data: {
  goods_type_id: any;
  quantity: any; // number
  order_count: any; // number
  is_quantity_public: boolean;
  sell_start_at: Date | null;
  sell_end_at: Date | null;
  pre_discount_rate: number | null;
  public_at: Date;
  is_custom: boolean;
  rank: any;
  lowStockMeta: LowStockMetaDto | null;
  limitedMeta: LimitedMetaDto | null;
  spo_item_stocks: {
    id: number;
    spo_id: number;
    quantity: number;
  }[];
  is_force_out_of_stock: boolean;
}): TNessBadgeListViewProps => {
  if (isLegacyStockProduct(data.goods_type_id)) {
    const sumOfStocks = data.spo_item_stocks.reduce((a, b) => a + b.quantity, 0);

    return {
      goodsTypeId: data.goods_type_id,
      legacyStock: {
        totalQuantity: data.quantity,
        orderCount: data.order_count,
        isQuantityPublic: data.is_quantity_public,
        isOutOfStock: sumOfStocks <= 0,
      },
      salePeriod: {
        startDate: data.sell_start_at ?? undefined,
        endDate: data.sell_end_at ?? undefined,
      },
      discountPercentage: data.pre_discount_rate ?? undefined,
      publicAt: data.public_at,
      rank: data.rank ?? undefined,
      isCustom: data.is_custom,
    };
  } else {
    return {
      goodsTypeId: data.goods_type_id,
      stock: {
        availableStock: data.spo_item_stocks.reduce((a, b) => a + b.quantity, 0),
      },
      salePeriod: {
        startDate: data.sell_start_at ?? undefined,
        endDate: data.sell_end_at ?? undefined,
      },
      discountPercentage: data.pre_discount_rate ?? undefined,
      publicAt: data.public_at,
      rank: data.rank ?? undefined,
      isCustom: data.is_custom,
      lowStockMeta: data.lowStockMeta ?? undefined,
      limitedMeta: data.limitedMeta ?? undefined,
    };
  }
};
